import {useContext} from "react";
import FormContext from "formContext";


const useSpecialismsHelper = () => {

  const {additionalData} = useContext(FormContext)
  const {user, specialisms} = additionalData;

  const findSpecialismIdByName = (name) => {
    const currentSpec = name ? specialisms.find(spec => spec.name === name) : null;
    return currentSpec ? currentSpec.id : '';
  }

  const getSpecialismNameById = () => {
    if (!user.specialism_id) {
      return user.specialism;
    }
    const currentSpec = user.specialism_id ? specialisms.find(spec => spec.id === user.specialism_id) : null;
    return currentSpec ? currentSpec.name : user.specialism;
  }

  return  {findSpecialismIdByName, getSpecialismNameById}
}

export default useSpecialismsHelper;
